<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5">
        <v-card class="elevation-2 pa-4">
          <v-card-text class="headline text-center">Setup Authenticator</v-card-text>

          <v-card-text class="text-center">
            <p>แสกน QR code ด้วย Google Authenticator</p>
            <v-img v-if="qrDataUrl" :src="qrDataUrl" max-width="220" class="mx-auto my-3" />
            <v-progress-circular v-else indeterminate color="primary" />
          </v-card-text>

          <v-card-text>
            <v-form ref="form" @submit.prevent="confirmSetup">
              <v-text-field
                outlined
                prepend-inner-icon="mdi-lock"
                label="Enter 6-digit code to confirm"
                v-model="code"
                :rules="[v => !!v || 'Required', v => (v && v.length === 6) || 'Must be 6 digits']"
                maxlength="6"
                type="number"
              />
            </v-form>
          </v-card-text>

          <v-card-actions class="px-4">
            <v-btn color="primary" block :loading="loading" @click="confirmSetup">Confirm & Enable MFA</v-btn>
          </v-card-actions>

          <v-card-text v-if="error" class="text-center red--text">{{ error }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/config/axios";
import qrcode from "qrcode";

export default {
  data: () => ({
    qrDataUrl: null,
    code: '',
    loading: false,
    error: '',
  }),

  async created() {
    try {
      const uid = this.$store.state.uid;
      const { data } = await axios.post('/mfa/setup', {}, {
        headers: { Authorization: 'Bearer ' + uid },
      });
      this.qrDataUrl = await qrcode.toDataURL(data.otpauth);
    } catch (err) {
      this.error = 'Failed to load QR code. Please try again.';
    }
  },

  methods: {
    async confirmSetup() {
      if (this.loading || !this.$refs.form.validate()) return;
      this.loading = true;
      this.error = '';
      try {
        const uid = this.$store.state.uid;
        await axios.post('/mfa/confirm', { code: this.code }, {
          headers: { Authorization: 'Bearer ' + uid },
        });
        this.$router.push({ name: 'admin' });
      } catch (err) {
        this.error = err.response?.data?.error || 'Invalid code, try again.';
        this.code = '';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
